export function buildTagItUserIdentifier(uid) {
  if (typeof uid !== "string" || !uid) return null;

  return {
    entityId: uid,
    entityidType: "id",
    entityidAlgo: "clear",
    entityidOwner: "sproutly.space",
  };
}
